var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{on:{"click":function($event){return _vm.down()}}},[_vm._t("default",[_c('el-button',{attrs:{"icon":"leniu-icon-export","type":"primary"}},[_vm._v("批量导出照片\n    ")])])],2)}
var staticRenderFns = []

export { render, staticRenderFns }